import styled from 'styled-components';
import { StyledAdminListHeaders } from '../../AdminListHeaderCell/styles/StyledAdminListHeaders';

export const StyledAdminPoolConfigsListHeader = styled.div`
  ${StyledAdminListHeaders}

  .admin-list-header-cell-container {
    &.id,
    &.port,
    &.algorithm,
    &.actions {
      flex-basis: initial;
      flex-grow: 0;
    }

    &.id {
      width: 6.4rem;
    }

    &.actions {
      width: 10.8rem;

      @media (min-width: 768px) and (max-width: 1440px) {
        width: 8.8rem;
      }
    }

    &.port,
    &.algorithm {
      width: 14.4rem;
    }
  }

  @media screen and (max-width: 1100px) {
    width: 110rem;
  }
`;
